
import { CheckCircle } from "lucide-react";

interface CompletedTripSegmentProps {
  destinationName: string;
}

const CompletedTripSegment = ({ destinationName }: CompletedTripSegmentProps) => {
  console.debug('📅 Past trip segment - not showing check-in options');
  
  return (
    <div className="bg-travel-50 rounded-lg p-3 space-y-2">
      <div className="flex items-center justify-center gap-2 text-travel-600">
        <CheckCircle className="w-4 h-4" />
        <span className="font-semibold text-sm">Trip Completed</span>
      </div>
    </div>
  );
};

export default CompletedTripSegment;
